<template>
  <b-collapse :key="componentKey" class="panel">
    <!-- <div slot="trigger" class="panel-heading"><strong>Dettagli</strong></div> -->
    <div class="panel-block">
      <form class="columns is-multiline" @submit.prevent="submit">
        <div
          class="column is-two-thirds"
          style="padding-left:12px; padding-right:10px"
        >
          <div class="columns is-multiline">
            <b-field
              :type="errors['internal_id'] ? 'is-danger' : ''"
              :message="errors['internal_id']"
              class="column"
              style="margin-bottom: 0"
            >
              <b-input
                placeholder="ID"
                custom-class="is-family-code"
                :value="item['internal_id']"
                @input="update('internal_id', $event)"
              />
            </b-field>
            <b-field
              :type="errors['name'] ? 'is-danger' : ''"
              :message="errors['name']"
              class="column is-two-thirds"
              style="margin-bottom: 0"
            >
              <b-input
                placeholder="Nome"
                :value="item['name']"
                @input="update('name', $event)"
              />
            </b-field>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="columns is-multiline is-gapless">
            <b-field
              :type="errors['prospect'] ? 'is-danger' : ''"
              :message="errors['prospect']"
              class="column is-half m-r-sm"
              style="margin-bottom: 0"
            >
              <b-select
                expanded
                :value="item['prospect']"
                @input="update('prospect', $event)"
              >
                <option value="0">Prospect</option>
                <option value="1">Cliente</option>
                <option value="2">Subrivenditore</option>
                <option value="3">Prospect Security</option>
                <option value="4">Cliente Security</option>
                <option value="5">Lead</option>
                <option value="6">Cliente inattivo</option>
              </b-select>
            </b-field>
            <b-field class="column" label>
              <a class="button" style="width:100%" @click="fillLegal()">
                Riempi sede legale
              </a>
            </b-field>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="columns is-multiline is-gapless">
            <b-field
              :type="errors['address'] ? 'is-danger' : ''"
              :message="errors['address']"
              class="column is-full"
            >
              <b-input
                placeholder="Indirizzo"
                size="is-small"
                :value="item['address']"
                @input="update('address', $event)"
              />
            </b-field>
            <b-field
              :type="errors['zip_code'] ? 'is-danger' : ''"
              :message="errors['zip_code']"
              class="column is-one-quarter"
            >
              <b-input
                placeholder="CAP"
                size="is-small"
                :value="item['zip_code']"
                @input="update('zip_code', $event)"
              />
            </b-field>
            <b-field
              :type="errors['town'] ? 'is-danger' : ''"
              :message="errors['town']"
              class="column m-l-sm m-r-sm"
            >
              <b-input
                placeholder="Comune"
                size="is-small"
                :value="item['town']"
                @input="update('town', $event)"
              />
            </b-field>
            <b-field
              :type="errors['province'] ? 'is-danger' : ''"
              :message="errors['province']"
              class="column is-one-fifth"
            >
              <b-input
                size="is-small"
                placeholder="Provincia"
                :value="item['province']"
                @input="update('province', $event)"
              />
            </b-field>
            <b-field
              :type="errors['vat_id'] ? 'is-danger' : ''"
              :message="errors['vat_id']"
              class="column is-half m-r-sm"
            >
              <b-input
                size="is-small"
                placeholder="P. IVA"
                :value="item['vat_id']"
                @input="update('vat_id', $event)"
              />
            </b-field>
            <b-field
              :type="errors['ssn_id'] ? 'is-danger' : ''"
              :message="errors['ssn_id']"
              class="column"
            >
              <b-input
                size="is-small"
                placeholder="Codice fiscale"
                :value="item['ssn_id']"
                @input="update('ssn_id', $event)"
              />
            </b-field>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="columns is-multiline is-gapless">
            <b-field
              :type="errors['legal_address'] ? 'is-danger' : ''"
              :message="errors['legal_address']"
              class="column is-full"
            >
              <b-input
                ref="legalAddressInput"
                size="is-small"
                placeholder="Sede legale"
                :value="
                  formData['legal_address']
                    ? formData['legal_address']
                    : item['legal_address']
                "
                @input="update('legal_address', $event)"
              />
            </b-field>
            <b-field
              :type="errors['legal_zip_code'] ? 'is-danger' : ''"
              :message="errors['legal_zip_code']"
              class="column is-one-quarter"
            >
              <b-input
                ref="legalZipCodeInput"
                size="is-small"
                placeholder="CAP"
                :value="
                  formData['legal_zip_code']
                    ? formData['legal_zip_code']
                    : item['legal_zip_code']
                "
                @input="update('legal_zip_code', $event)"
              />
            </b-field>
            <b-field
              :type="errors['legal_town'] ? 'is-danger' : ''"
              :message="errors['legal_town']"
              class="column m-l-sm m-r-sm"
            >
              <b-input
                ref="legalTownInput"
                size="is-small"
                placeholder="Comune"
                :value="
                  formData['legal_town']
                    ? formData['legal_town']
                    : item['legal_town']
                "
                @input="update('legal_town', $event)"
              />
            </b-field>
            <b-field
              :type="errors['legal_province'] ? 'is-danger' : ''"
              :message="errors['legal_province']"
              class="column is-one-fifth"
            >
              <b-input
                ref="legalProvinceInput"
                size="is-small"
                placeholder="Provincia"
                :value="
                  formData['legal_province']
                    ? formData['legal_province']
                    : item['legal_province']
                "
                @input="update('legal_province', $event)"
              />
            </b-field>
            <b-field
              :type="errors['payment_method'] ? 'is-danger' : ''"
              :message="errors['payment_method']"
              class="column is-two-thirds"
            >
              <b-select
                size="is-small"
                expanded
                icon="credit-card"
                placeholder="metodo di pagamento"
                :value="item['payment_method']"
                @input="update('payment_method', $event)"
              >
                <option
                  v-for="(choice, key) in fields['payment_method']['choices']"
                  :key="key"
                  :value="key"
                >
                  {{ choice.name }}
                </option>
              </b-select>
            </b-field>
            <b-field
              :type="errors['public_entity'] ? 'is-danger' : ''"
              :message="errors['public_entity']"
              class="column is-one-third"
            >
              <div class="is-pulled-right" style="margin-top: 2px;">
                <b-checkbox
                  size="is-small"
                  :value="item['public_entity']"
                  @input="update('public_entity', $event)"
                >
                  ente pub.
                </b-checkbox>
              </div>
            </b-field>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="columns is-multiline is-gapless">
            <b-field
              :type="errors['email'] ? 'is-danger' : ''"
              :message="errors['email']"
              class="column is-full m-r-sm"
            >
              <b-input
                expanded
                size="is-small"
                placeholder="E-mail"
                icon="envelope"
                :value="item['email']"
                @input="update('email', $event)"
              />
            </b-field>
            <b-field
              :type="errors['phone'] ? 'is-danger' : ''"
              :message="errors['phone']"
              class="column is-half m-r-sm"
            >
              <b-input
                size="is-small"
                placeholder="Telefono"
                icon="phone"
                :value="item['phone']"
                @input="update('phone', $event)"
              />
            </b-field>
            <b-field
              :type="errors['website'] ? 'is-danger' : ''"
              :message="errors['website']"
              class="column"
            >
              <b-input
                size="is-small"
                placeholder="Sito web"
                icon="globe"
                :value="item['website']"
                @input="update('website', $event)"
              />
            </b-field>

            <b-field
              :type="errors['sdi_code'] ? 'is-danger' : ''"
              :message="errors['sdi_code']"
              class="column is-half m-r-sm"
            >
              <b-input
                size="is-small"
                placeholder="Codice SDI"
                :value="item['sdi_code']"
                @input="update('sdi_code', $event)"
              />
            </b-field>
            <b-field
              :type="errors['pec'] ? 'is-danger' : ''"
              :message="errors['pec']"
              class="column"
            >
              <b-input
                size="is-small"
                placeholder="PEC"
                icon="envelope"
                :value="item['pec']"
                @input="update('pec', $event)"
              />
            </b-field>
          </div>
        </div>
        <b-field
          :type="errors['notes'] ? 'is-danger' : ''"
          :message="errors['notes']"
          class="column is-two-thirds"
          style="padding-top: 0; margin-bottom: 0"
        >
          <b-input
            size="is-small"
            placeholder="Note"
            type="textarea"
            :value="item['notes']"
            rows="1"
            @input="update('notes', $event)"
          />
        </b-field>
        <b-field
          :type="errors['id_code'] ? 'is-danger' : ''"
          :message="errors['id_code']"
          class="column is-one-third"
          style="padding-top: 0; margin-bottom: 0"
        >
          <b-input
            size="is-small"
            placeholder="Codice identificativo"
            type="textarea"
            :value="item['id_code']"
            rows="1"
            @input="update('id_code', $event)"
          />
        </b-field>
        <b-field class="column is-full has-text-right">
          <div style="float:right">
            <span
              style="padding: 2px 5px 0; font-weight: bold; font-size: 90%"
            >
              Service term
            </span>
            <b-input
              size="is-small"
              type="number"
              min="0"
              :value="item['service_term']"
              @input="update('service_term', $event)"
              style="display: inline-block; width: 60px"
            ></b-input>
          </div>
        </b-field>
        <footer v-if="!isEmpty(formData)" class="column is-full">
          <div class="buttons">
            <button class="button" type="button" @click="reset">
              <b-icon icon="undo"></b-icon>
              <span>Annulla</span>
            </button>
            <button class="button is-primary" type="submit">
              <b-icon icon="save"></b-icon>
              <span>Salva</span>
            </button>
          </div>
        </footer>
      </form>
    </div>
  </b-collapse>
</template>

<script>
import isEmpty from "lodash/isEmpty"
import { call } from "vuex-pathify"

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    fields: {
      type: Object,
      required: true
    },
    submitAction: {
      type: Function,
      default: call("customers/update")
    },
    redirectRoute: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: {},
      errors: {}
    }
  },
  methods: {
    isEmpty,
    reset() {
      this.errors = {}
      this.formData = {}
      this.componentKey += 1
    },
    fillLegal() {
      this.update(
        "legal_address",
        this.formData.address ? this.formData.address : this.item.address
      )
      this.update(
        "legal_province",
        this.formData.province ? this.formData.province : this.item.province
      )
      this.update(
        "legal_zip_code",
        this.formData.zip_code ? this.formData.zip_code : this.item.zip_code
      )
      this.update(
        "legal_town",
        this.formData.town ? this.formData.town : this.item.town
      )
    },
    update(name, value) {
      this.$set(this.formData, name, value)
    },
    async submit() {
      try {
        let response, message

        if (this.formData.province) {
          this.formData.province = this.formData.province.toUpperCase()
        }

        if (this.formData.legal_province) {
          this.formData.legal_province = this.formData.legal_province.toUpperCase()
        }

        if (!isEmpty(this.item)) {
          // if we're editing
          response = await this.submitAction({
            id: this.item.id,
            data: this.formData
          })
          message = "Modificato con successo"
        } else {
          // if it's a new item
          response = await this.submitAction(this.formData)
          message = "Creato con successo"
        }
        this.$toast.open({
          message,
          type: "is-success"
        })

        // if the `redirectRoute` prop is set, redirect to the
        // path with that name.
        // as a convention, we always pass an `id` param with
        // the value coming from the previous response.
        if (this.redirectRoute) {
          this.$router.push({
            name: this.redirectRoute,
            params: { id: response.id }
          })
        } else {
          this.reset()
        }
      } catch (response) {
        // show errors in form
        this.errors = {}
        Object.keys(response.data).forEach(key => {
          this.$set(this.errors, key, response.data[key].join(" "))
        })
      }
    }
  }
}
</script>

<style lang="sass">
.columns.is-gapless > .column
  margin-bottom: 10px
.field label
  font-size: 0.8rem
  text-transform: uppercase
</style>
